import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const BillingContext = createContext(null);

export function BillingProvider({ children }) {
  const { user } = useAuth();
  const [billing, setBilling] = useState(null);

  const refreshBilling = useCallback(async () => {
    try {
      const { data } = await api.get("/billing/me");
      setBilling(data);
    } catch {
      setBilling(null);
    }
  }, []);

  useEffect(() => {
    if (user) refreshBilling();
    else setBilling(null);
  }, [user, refreshBilling]);

  return <BillingContext.Provider value={{ billing, refreshBilling }}>{children}</BillingContext.Provider>;
}

export const useBilling = () => useContext(BillingContext);
